import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { TravelerCaptureSource } from '@bandido/shared/types';
import { CaptureSourceContent } from './CaptureSourceViewer';
import { CaptureSourceThumbnail } from './CaptureSourceThumbnail';

export const CaptureReviewSources = ({
  caseId,
  sources,
  selected,
  onSelect,
}: {
  caseId: number;
  sources: TravelerCaptureSource[];
  selected?: TravelerCaptureSource;
  onSelect: (source: TravelerCaptureSource) => void;
}) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ minWidth: 0, height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <Typography variant="subtitle1" fontWeight={600}>
        {t('copilot.capture.sourcePanel')}
      </Typography>
      <Stack direction="row" gap={1} sx={{ overflowX: 'auto', py: 1, flexShrink: 0 }}>
        {sources.map((source, index) => (
          <Box
            key={source.id}
            sx={{
              flexShrink: 0,
              display: 'flex',
              flexDirection: 'column',
              border: 2,
              borderColor: selected?.id === source.id ? 'primary.main' : 'transparent',
              borderRadius: 1,
            }}
          >
            {source.kind === 'file' && (
              <CaptureSourceThumbnail caseId={caseId} source={source} compact onOpen={() => onSelect(source)} />
            )}
            <Button size="small" aria-pressed={selected?.id === source.id} onClick={() => onSelect(source)}>
              {t('copilot.capture.sourceNumber', { number: index + 1 })}
            </Button>
          </Box>
        ))}
      </Stack>
      {selected && (
        <>
          <Typography variant="caption" display="block" noWrap title={selected.label} sx={{ mb: 1, flexShrink: 0 }}>
            {selected.label}
          </Typography>
          <CaptureSourceContent key={selected.id} caseId={caseId} source={selected} embedded />
        </>
      )}
    </Box>
  );
};
